import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[uexDisabled]',
  host: {
    '[attr.disabled]': 'disabled ? true : null'
  }
})
export class DisabledDirective {
  @Input('uexDisabled') disabled: boolean;
}
